import React from 'react';
import { SignInForm } from '../../components/user_management/signin-form';
import config from '../../utils/config';
import './user_management.css';
import { useTheme } from 'styled-components';

export function SignIn(props) {
	const theme = useTheme();
	return (
		<div className="bg-overlay-dark">
			<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
				<div className="m-4 text-center">
					<p
						style={{
							color: theme.TA_GREEN,
							fontSize: '2.625rem',
							fontWeight: 400,
							margin: '10px 0'
						}}
					>
						Hire Outstanding Software Engineers Now!
					</p>
					<div style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
						<p>Enter your credentials below</p>
					</div>
				</div>
				<div className="p-4 mt-0 my-md-4 ta-form-container d-flex justify-content-center">
					<SignInForm
						forgetPassordUrl={config.URIs.forget_password_uri}
						signInUrl={config.URIs.sign_in_uri}
						onLoginSuccessRedirect="/dashboard/jobs"
						{...props}
					/>
				</div>
			</div>
		</div>
	);
}
